











import Vue from "vue";
import Modal from "./Modal.vue";

export default Vue.extend({
  components: { Modal }
});
